import sectionItemsGridCss from '../css-snippets/section-items-grid';

const html = `
<style>${sectionItemsGridCss}</style>
<div
  class="wrapper-container"
  id="items-grid-section-unique-id"
  data-id="unique-id"
  data-attribute="wrapper-container"
  data-background-color="#ffffff"
  style="
    background-color: rgb(255, 255, 255);
    background-image: none;
  "
  data-enable-background-image="false"
  data-background-img=""
  data-background="#ffffff"
  data-top-padding="true"
  data-bottom-padding="true"
>
  <div data-attribute="wrapper-content" class="wrapper-content container">
    <div data-attribute="title-content" class="content-head">
      <h2 style="text-align: center">
        <span style="background-color: transparent; color: rgb(0, 0, 0)"
          ><strong>Stop UTIs &amp; Kidney Disease in Its Tracks</strong></span
        >
      </h2>
      <p style="text-align: center">
        These cutting-edge features make VetiFlow™ the most advanced solution
        for preventing kidney disease available today.
      </p>
      <h2 style="text-align: center">
        <span style="background-color: transparent; color: hsl(210, 75%, 60%)"
          ><strong>Cutting-Edge Features of VetiFlow™</strong></span
        >
      </h2>
    </div>
    <div class="swiper">
      <div data-attribute="list-item" data-col-per-view="5" class="list-item swiper-wrapper">
        <div data-attribute="item" class="item swiper-slide">
          <div class="wrap-imge">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2025/12/03/image-692faa668b6f11bbc2320d73.webp?w=400&amp;h=50&amp;q=80"
              alt=""
            />
          </div>
          <div data-attribute="text-item" class="wrap-text">
            <h3 style="text-align: center">Triple-Defense PRO™ Technology</h3>
            <p style="text-align: center">
              Uses continuous circulation, 3-stage filtration, and dilution
              protocol to make biofilm formation physically impossible
            </p>
          </div>
        </div>
  
        <div data-attribute="item" class="item swiper-slide">
          <div class="wrap-imge">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2025/12/03/image-692faa70a7a7b040ae407064.png?w=400&amp;h=50&amp;q=80"
              alt=""
            />
          </div>
          <div data-attribute="text-item" class="wrap-text">
            <h3 style="text-align: center">
              <strong>Large 3.2 Liter Capacity</strong>
            </h3>
            <p style="text-align: center">
              <span
                style="
                  background-color: rgb(250, 252, 255);
                  color: rgb(48, 48, 48);
                "
                >Perfect size for 1-2 dogs - refill weekly instead of daily. No
                more constant trips to the sink</span
              >
            </p>
          </div>
        </div>
  
        <div data-attribute="item" class="item swiper-slide">
          <div class="wrap-imge">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2025/12/03/image-692faa79ce1200b53456c4ed.webp?w=400&amp;h=50&amp;q=80"
              alt=""
            />
          </div>
          <div data-attribute="text-item" class="wrap-text">
            <h3 style="text-align: center">
              <strong>Whisper-Quiet Operation</strong>
            </h3>
            <p style="text-align: center">
              Under 40dB - quieter than a library. Won't disturb you or scare
              timid dogs
            </p>
          </div>
        </div>
  
        <div data-attribute="item" class="item swiper-slide">
          <div class="wrap-imge">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2025/12/03/image-692faa83ab563d4431debcc7.webp?w=400&amp;h=50&amp;q=80"
              alt=""
            />
          </div>
          <div data-attribute="text-item" class="wrap-text">
            <h3 style="text-align: center">
              <strong>Medical-Grade Materials</strong>
            </h3>
            <p style="text-align: center">
              BPA-free components and antimicrobial surfaces. Dishwasher-safe for
              easy weekly cleaning
            </p>
          </div>
        </div>
  
        <div data-attribute="item" class="item swiper-slide">
          <div class="wrap-imge">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2025/12/03/image-692faa8ca562cc263d0e8444.webp?w=400&amp;h=50&amp;q=80"
              alt=""
            />
          </div>
          <div data-attribute="text-item" class="wrap-text">
            <h3 style="text-align: center"><strong>5-Year Warranty</strong></h3>
            <p style="text-align: center">
              Unlike competitors' 90-day warranties, we guarantee the pump for 5
              full years - because we built it to last
            </p>
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</div>
`;
export default html;
